export const tripsConstants = {
  INIT: 'FETCH_TRIPS_INIT',
  SUCCESS: 'FETCH_TRIPS_SUCCESS',
  FAILURE: 'FETCH_TRIPS_FAILURE',
  CLEAR: 'FETCH_TRIPS_CLEAR',
}
